module.exports = __webpack_public_path__ + "static/img/carousel3.155f1a7e.jpg";